import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
// Routes
import admin from './admin/admin'
import frontend from './frontend/frontend'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'front-home' } },
    ...frontend,
    ...admin,
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/admin/Login.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
        resource: 'Auth',
      },
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/views/admin/Register.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/pages/miscellaneous/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/error/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
  const userData = getUserData()
  const ability = userData ? userData.ability : []
  let found = false
  const BreakException = {}

  const isLoggedIn = isUserLoggedIn()
  // Redirect to login if not logged in
  if (isLoggedIn === null && !canNavigate(to)) {
    if (!isLoggedIn && to.path !== '/login') return next({ name: 'login' })

    if (to.path !== '/pages/miscellaneous/not-authorized') {
      // If logged in => not authorized
      return next({ name: 'misc-not-authorized' })
    }
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next(getHomeRouteForLoggedInUser(userData ? userData.roles[0] : null))
  }

  if (!hasQueryParams(to) && hasQueryParams(from)) {
    return next({ name: to.name, query: from.query })
  }

  if (to.meta.resource && (to.meta.resource !== '*' && to.meta.resource !== 'Auth')) {
    try {
      Object.keys(ability).forEach(key => {
        if (ability[key].subject === to.meta.resource) {
          found = true
          throw BreakException
        }
      })
    } catch (e) {
      console.log(e)
    }
  } else {
    found = true
  }
  if (!found) {
    return next({ name: 'misc-not-authorized' })
  }

  return next()
})

export default router
